var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTag3(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 65,
    height: 18,
    viewBox: "0 0 65 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 87"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 63,
    height: 16,
    rx: 8,
    stroke: "#0C45CC",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 18",
    cx: 11,
    cy: 9,
    r: 3,
    fill: "#0C45CC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTag3);
export default __webpack_public_path__ + "static/media/tag_3.a9ecbbb73cab8b7cf2625dc85ac17e6d.svg";
export { ForwardRef as ReactComponent };